enum SubSatgasEnum {
  GAKKUMTPPO = 1,
  GAKKUMJUDOL = 2,
  GAKKUMJUKON = 3,
  GAKKUMNARKO = 4,
  GAKKUMLUNDUPSDA = 5,
  GAKKUMLUNDUPIMP = 6,
  GAKKUMTIPIDKOR = 7,
  CGHTPPO = 8,
  CGHJUDOL = 9,
  CGHJUKON = 10,
  CGHNARKO = 11,
  CGHLUNDUP = 12,
  CGHTIPIDKOR = 13,
}

export default SubSatgasEnum